import { useEffect } from "react";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { groupsSelector } from "@store/groups/groups-selector";
import { fetchGroups } from "@store/groups/groups-slice-thunk";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** A hook that returns all groups the user has access to */
export function useGroups(): FaroCoreApiTypes.GroupSummaryResponse[] {
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const groups = useAppSelector(groupsSelector);

  // Fetch all the groups in the company
  useEffect(() => {
    async function fetchGroupsViaStore(): Promise<void> {
      await dispatch(
        fetchGroups({
          companyId,
        })
      );
    }
    void fetchGroupsViaStore();
  }, [companyId, dispatch]);

  return groups;
}
